import React from "react";
import contextProvider from "../../contextProvider";
import { Row, Col, ButtonGroup } from "reactstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";
import Panel from "../../_L1_components/Layout/Panel";
import ApCoverageTable from "../Elements/ApCoverageTable";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
// import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import Section from "../../_L1_components/Layout/Section";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import ReactOCollapse from "../../_L1_components/Elements/ReactOCollapse";

const context_exposed_methods = [];

class ApCoverage extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      outOfRange: false,
      msgCopy: "Copy link",
    };
    super(props, initState);

    this.apiStore = null;
    this.adapted = {};
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // this._disable_offset = false;

    this.apiStore = this.getAppContext().getApiStoreService();
    this._view_form.init();
    this._view_form.submit();
    this.getProbeConf();
  }

  formatOffset(seconds) {
    if (seconds == 0) {
      return "";
    }
    let isFuture = seconds < 0 ? false : true;
    seconds = seconds < 0 ? seconds * -1 : seconds;
    let weeks = parseInt(seconds / 60 / 60 / 24 / 7);
    let weeksStr = weeks + " week" + (weeks > 1 ? "s" : "");
    let days = parseInt(seconds / 60 / 60 / 24) % 7;
    let daysStr = days + " day" + (days > 1 ? "s" : "");
    let hours = parseInt(seconds / 60 / 60) % 24;
    let hoursStr = hours + " hour" + (hours > 1 ? "s" : "");
    let minutes = parseInt(seconds / 60) % 60;
    let minutesStr = minutes + " minute" + (minutes > 1 ? "s" : "");
    return (
      (!isFuture ? "- " : "+ ") +
      (weeks > 0 ? weeksStr + " " : "") +
      (days > 0 ? daysStr + " " : "") +
      (hours > 0 ? hoursStr + " " : "") +
      (minutes > 0 ? minutesStr + " " : "")
    );
  }

  // cleanKey(key, replace) {
  //   const data = key.split(replace);
  //   if (data.length == 1) {
  //     return key;
  //   } else {
  //     return data[data.length - 1];
  //   }
  // }

  // adapterResponse(obj) {
  //   // console.log("obj", obj);
  //   const keyValues = Object.entries(obj).map(([key, value]) => {
  //     let newKey = this.cleanKey(key, "#");
  //     if (typeof value === "object" && value !== null && !Array.isArray(value)) {
  //       value = this.adapterResponse(value);
  //     }
  //     return [newKey, value];
  //   });
  //   let adapted = Object.fromEntries(keyValues);
  //   console.log("adapted", adapted);
  //   return obj;
  // }

  onComponentWillUnmount() {}

  loadApCoverage(data, cb, opts) {
    let from_ts =
      data.is_preset == "yes"
        ? this.getAppContext().momentjs().unix() - parseInt(data.view_preset)
        : data.stime;
    let to_ts =
      data.is_preset == "yes" ? this.getAppContext().momentjs().unix() : data.etime;

    if (
      this._view_form.getEntry("offset") != false &&
      this._view_form.getEntry("offset") != undefined
    ) {
      from_ts += this._view_form.getEntry("offset");
      to_ts += this._view_form.getEntry("offset");

      // let _futureRange = to_ts - from_ts;
      // let _futureOffset = this._view_form.getEntry("offset") + _futureRange / 2;
      // let _future_to_ts = to_ts + _futureOffset;

      // if (_future_to_ts > this.getAppContext().momentjs().unix()) {
      //   this._disable_offset = true;
      // } else {
      //   this._disable_offset = false;
      // }
    }

    // this.setState({ data: undefined });

    this.setState({ loading: true, from_ts: from_ts, to_ts: to_ts }, () => {
      this.apiStore.fire("apcoverage", {
        data: {
          probeid: this.props.match.params.probeuid,
          command: "ap_coverage",
          from_ts: from_ts,
          to_ts: to_ts,
        },
        ___onSuccess: (status, response_data) => {
          // const response_data = this.adapterResponse(res);
          if (
            Object.keys(response_data.coverage).length == 0 &&
            from_ts > this.getAppContext().momentjs().unix()
          ) {
            this.setState({
              outOfRange: true,
              loading: false,
            });
          } else {
            let _rawRssi = {};
            let _rawRssi_rogue = {};

            this.know_ap = Object.keys(response_data.coverage).filter((value) => {
              return value != "ROGUE";
            }).length;

            let know_essid = [];
            let know_bssid = [];

            let unknow_essid = [];
            let unknow_bssid = [];

            Object.keys(response_data.coverage)
              .filter((value) => {
                return value != "ROGUE";
              })
              .forEach((_apname, id) => {
                Object.keys(response_data.coverage[_apname]).forEach((essid, id2) => {
                  know_essid.push(essid);
                  Object.keys(response_data.coverage[_apname][essid]).forEach(
                    (freq, id3) => {
                      know_bssid.push(response_data.coverage[_apname][essid][freq].bssid);
                      let keyName =
                        response_data.coverage[_apname][essid][freq].RSSI +
                        "_" +
                        freq +
                        "_" +
                        essid +
                        "_" +
                        _apname;

                      _rawRssi[keyName] = {
                        apname: _apname,
                        essid: essid,
                        freq: freq,
                        rssi: response_data.coverage[_apname][essid][freq].RSSI,
                        rssi_max: response_data.coverage[_apname][essid][freq].RSSI_MAX,
                        rssi_min: response_data.coverage[_apname][essid][freq].RSSI_MIN,
                        bssid: response_data.coverage[_apname][essid][freq].bssid,
                        perc: response_data.coverage[_apname][essid][freq].perc,
                        views: response_data.coverage[_apname][essid][freq].views,
                      };
                    }
                  );
                });
              });

            this.know_essid = [...new Set(know_essid)];
            this.know_bssid = [...new Set(know_bssid)];

            let obj = this.sort(_rawRssi).customObj;
            let rowSpanAp = this.sort(_rawRssi).rowSpanAp;
            let classApStriped = this.sort(_rawRssi).classApStriped;

            Object.keys(response_data.coverage)
              .filter((value) => {
                return value == "ROGUE";
              })
              .forEach((_apname, id) => {
                Object.keys(response_data.coverage[_apname]).forEach((essid, id2) => {
                  unknow_essid.push(essid);
                  Object.keys(response_data.coverage[_apname][essid]).forEach(
                    (freq, id3) => {
                      unknow_bssid.push(
                        response_data.coverage[_apname][essid][freq].bssid
                      );
                      let keyName =
                        response_data.coverage[_apname][essid][freq].RSSI +
                        "_" +
                        freq +
                        "_" +
                        essid +
                        "_" +
                        _apname;

                      _rawRssi_rogue[keyName] = {
                        apname: _apname,
                        essid: essid,
                        freq: freq,
                        rssi: response_data.coverage[_apname][essid][freq].RSSI,
                        rssi_max: response_data.coverage[_apname][essid][freq].RSSI_MAX,
                        rssi_min: response_data.coverage[_apname][essid][freq].RSSI_MIN,
                        bssid: response_data.coverage[_apname][essid][freq].bssid,
                        perc: response_data.coverage[_apname][essid][freq].perc,
                        views: response_data.coverage[_apname][essid][freq].views,
                      };
                    }
                  );
                });
              });

            this.unknow_essid = [...new Set(unknow_essid)];
            this.unknow_bssid = [...new Set(unknow_bssid)];

            let obj_rogue = this.sort(_rawRssi_rogue).customObj;
            let rowSpanAp_rogue = this.sort(_rawRssi_rogue).rowSpanAp;
            let classApStriped_rogue = this.sort(_rawRssi_rogue).classApStriped;

            this.setState({
              data: response_data,
              data_know: {
                obj: obj,
                rowSpanAp: rowSpanAp,
                classApStriped: classApStriped,
              },
              data_unknow: {
                obj: obj_rogue,
                rowSpanAp: rowSpanAp_rogue,
                classApStriped: classApStriped_rogue,
              },
              loading: false,
              outOfRange: false,
            });
          }
        },
        ___onError: (error, data) => {
          this.setState(
            {
              loading: false,
            },
            () => {
              console.error(error);
            }
          );
        },
      });
    });
  }

  sort(_rawRssi) {
    let _rawAp = [];

    Object.keys(_rawRssi)
      .sort()
      .forEach((val, id) => {
        _rawAp.push(_rawRssi[val].apname);
      });

    let rowSpanAp = {};

    _rawAp.forEach((apname) => {
      rowSpanAp[apname] = (rowSpanAp[apname] || 0) + 1;
    });

    let _ApSortedList = [...new Set(_rawAp)];

    let customObj = {};
    let classApStriped = {};

    _ApSortedList.forEach((apname, id) => {
      if (id % 2 != 0) {
        classApStriped[apname] = "row-stripe-table";
      } else {
        classApStriped[apname] = "";
      }
      customObj[id] = { [apname]: {} };
      let _arrayOfEssid = [];
      let _arrayOfFreq = [];

      Object.keys(_rawRssi)
        .sort()
        .forEach((val, id) => {
          if (_rawRssi[val].apname == apname) {
            _arrayOfEssid.push(_rawRssi[val].essid);
            _arrayOfFreq.push({
              freq: _rawRssi[val].freq,
              rssi: _rawRssi[val].rssi,
              essid: _rawRssi[val].essid,
              rssi_max: _rawRssi[val].rssi_max,
              rssi_min: _rawRssi[val].rssi_min,
              bssid: _rawRssi[val].bssid,
              perc: _rawRssi[val].perc,
              views: _rawRssi[val].views,
            });
          }
        });

      let _arrayOfEssidList = [...new Set(_arrayOfEssid)];

      _arrayOfEssidList.forEach((essid, id2) => {
        customObj[id][apname] = {
          ...customObj[id][apname],
          [id2]: { [essid]: {} },
        };
      });

      _arrayOfEssidList.forEach((essid, id2) => {
        _arrayOfFreq.forEach((content, id3) => {
          if (Object.keys(customObj[id][apname][id2]) == content.essid) {
            customObj[id][apname][id2][essid] = {
              ...customObj[id][apname][id2][essid],
              [id3]: content,
            };
          }
        });
      });
    });

    return { customObj: customObj, rowSpanAp: rowSpanAp, classApStriped: classApStriped };
  }

  getProbeConf() {
    this.apiStore.fire("probe_cst_sync_status", {
      data: {
        probeuid: this.props.match.params.probeuid,
      },
      ___onSuccess: (status, data) => {
        this.setState({
          conf_set: data,
        });
      },
    });
  }

  componentDidUpdate(prev_props) {
    if (
      prev_props.match.params.probeuid !== undefined &&
      this.props.match.params.probeuid != prev_props.match.params.probeuid &&
      this._view_form
    ) {
      this._view_form.submit();
      this.getProbeConf();
    }
  }

  onRender() {
    return (
      <Section designType="wide">
        <Section designType="wide" className="mb-4 border-bottom border-3 border-gray300">
          <div className="d-flex px-4 pt-4 pb-3">
            <div className="flex-grow-1 align-self-end">
              <span className="align-middle">
                <div className="d-flex align-items-baseline">
                  <h2>AP coverage</h2>
                  {/* <div
                    id="tp_copy_link"
                    style={{ cursor: "pointer" }}
                    onMouseEnter={() => {
                      this.setState({ msgCopy: "Copy link" });
                    }}
                    onClick={() => {
                      this.getAppContext().copyURL();
                      this.setState({ msgCopy: "Copied" });
                    }}
                    onMouseLeave={() => {
                      setTimeout(() => {
                        this.setState({ msgCopy: "Copy link" });
                      }, 200);
                    }}
                    className="ml-3"
                  >
                    <small className="icon-link" />
                  </div>
                  <ReactOTooltip
                    placement="right"
                    target="tp_copy_link"
                    text={this.state.msgCopy}
                  /> */}
                </div>
              </span>
              <small className="text-muted"></small>
            </div>
            {this.state.loading == false ? (
              <div className="align-self-end text-right">
                {this.getAppContext().isCloud() ? (
                  <div>
                    {this.state.conf_set &&
                    this.state.conf_set.probe_status == "not_deployed" &&
                    this.state.conf_set.sync_status == 1 ? (
                      <small className="text-muted">Probe not deployed</small>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 1 ? (
                      <small className="text-muted">Probe in maintenance</small>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <small className="text-muted">
                        Probe <span className="text-danger">Offline</span>
                      </small>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "not_deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <small className="text-muted">
                        Probe not deployed <span className="text-danger">Offline</span>
                      </small>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <small className="text-muted">
                        Probe in maintenance <span className="text-danger">Offline</span>
                      </small>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </Section>

        <Section designType="wide" className="mx-4 mb-3">
          <Row noGutters>
            <Col xs={12} lg={8}>
              <ReactOForm
                onControllerReady={(form_controller) => {
                  this._view_form = form_controller;
                }}
                onSubmit={(data, submit_cb, opt) => {
                  this.loadApCoverage(data, submit_cb, opt);
                }}
              >
                <Row>
                  <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                    <ReactOActionBar padding="0" alignV="start">
                      <ReactOFormInput
                        type="hidden"
                        data_key="stime"
                        default={this.getAppContext().momentjs().unix()}
                      />
                      <ReactOFormInput
                        type="hidden"
                        data_key="etime"
                        default={this.getAppContext().momentjs().unix()}
                      />
                      <ReactOFormInput type="hidden" data_key="offset" default={false} />

                      <ReactOFormInput
                        type="hidden"
                        data_key="is_preset"
                        default={"yes"}
                      />

                      <ReactOFormInput
                        type="select"
                        data_key="view_preset"
                        color={
                          this._view_form &&
                          this._view_form.getEntry("is_preset") == "yes"
                            ? "primary"
                            : "secondary"
                        }
                        outline={
                          this._view_form && this._view_form.getEntry("is_preset") == "no"
                        }
                        noSelectionLabel="Choose preset"
                        default={
                          this.getAppContext()
                            .getLocalStorageService()
                            .isSet("ap_coverage_view")
                            ? this.getAppContext()
                                .getLocalStorageService()
                                .get("ap_coverage_view").view_preset
                            : 3600 * 4
                        }
                        onOptionSelect={(form_ctrl, selected_value) => {
                          form_ctrl.handleFormChange("view_preset", selected_value);
                          form_ctrl.handleFormChange("is_preset", "yes");
                          this._view_form.handleFormChange("offset", false);
                          this.getAppContext()
                            .getLocalStorageService()
                            .set("ap_coverage_view", this._view_form.getFormData());
                          form_ctrl.submit();
                        }}
                        options={(form_data) => {
                          return [
                            {
                              name:
                                form_data.offset !== undefined && form_data.offset != 0
                                  ? "1 hour"
                                  : "Last hour",
                              value: 3600,
                            },
                            {
                              name:
                                form_data.offset !== undefined && form_data.offset != 0
                                  ? "4 hours"
                                  : "Last 4 hours",
                              value: 3600 * 4,
                            },
                            {
                              name:
                                form_data.offset !== undefined && form_data.offset != 0
                                  ? "24 hours"
                                  : "Last 24 hours",
                              value: 3600 * 24,
                            },
                            {
                              name:
                                form_data.offset !== undefined && form_data.offset != 0
                                  ? "3 days"
                                  : "Last 3 days",
                              value: 3600 * 24 * 3,
                            },
                          ];
                        }}
                      />
                    </ReactOActionBar>
                  </Col>
                  <Col>
                    <ReactOActionBar padding="0" alignV="start">
                      <div>
                        {(() => {
                          let _offset =
                            this._view_form && this._view_form.isInitialized()
                              ? this._view_form.getEntry("offset")
                              : 0;
                          return (
                            <ButtonGroup>
                              <ReactOButton
                                icon="navigate-prev"
                                color={
                                  _offset !== undefined && _offset < 0
                                    ? "success"
                                    : "secondary"
                                }
                                outline={_offset === undefined || _offset >= 0}
                                disabled={
                                  this.state.loading ||
                                  (this._view_form &&
                                    this._view_form.getEntry("is_preset") == "yes")
                                }
                                onClick={() => {
                                  let _range =
                                    this._view_form.getEntry("etime") -
                                    this._view_form.getEntry("stime");
                                  let _offset = this._view_form.getEntry("offset") || 0;
                                  let _new_offset =
                                    _offset !== undefined
                                      ? _offset - _range / 2
                                      : _range / 2;
                                  this._view_form.handleFormChange(
                                    "offset",
                                    _new_offset == 0 ? false : _new_offset
                                  );
                                  this._view_form.submit();
                                }}
                              />
                              <ReactOButton
                                icon="navigate-next"
                                color={
                                  _offset !== undefined && _offset > 0
                                    ? "success"
                                    : "secondary"
                                }
                                outline={_offset === undefined || _offset <= 0}
                                disabled={
                                  this.state.loading ||
                                  (this._view_form &&
                                    this._view_form.getEntry("is_preset") == "yes") ||
                                  this._disable_offset == true
                                }
                                onClick={() => {
                                  let _range =
                                    this._view_form.getEntry("etime") -
                                    this._view_form.getEntry("stime");
                                  let _offset = this._view_form.getEntry("offset") || 0;
                                  let _new_offset =
                                    _offset !== undefined
                                      ? _offset + _range / 2
                                      : _range / 2;
                                  this._view_form.handleFormChange(
                                    "offset",
                                    _new_offset == 0 ? false : _new_offset
                                  );
                                  this._view_form.submit();
                                }}
                              />
                            </ButtonGroup>
                          );
                        })()}
                        {this._view_form &&
                        this._view_form.isInitialized() &&
                        this._view_form.getEntry("offset") !== undefined ? (
                          <ButtonGroup className="ml-2">
                            <ReactOButton
                              color="secondary"
                              outline
                              disabled
                              style={{ opacity: 1 }}
                            >
                              {this.formatOffset(this._view_form.getEntry("offset") || 0)}
                            </ReactOButton>
                            <ReactOButton
                              icon="close-outline"
                              disabled={this.state.loading}
                              onClick={() => {
                                this._view_form.handleFormChange("offset", false);
                                this._view_form.submit();
                              }}
                            />
                          </ButtonGroup>
                        ) : null}
                      </div>

                      <DateRangePicker
                        initialSettings={{
                          maxDate: this.getAppContext().momentjs(),
                          maxSpan: {
                            days: 3,
                          },
                          startDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("stime"),
                                  "X"
                                )
                              : this.getAppContext().momentjs(),
                          endDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("etime"),
                                  "X"
                                )
                              : this.getAppContext().momentjs(),
                          autoApply: true,
                        }}
                        onApply={(e, picker) => {
                          if (picker.endDate.unix() - picker.startDate.unix() > 259199) {
                            this._view_form.handleFormChange("is_preset", "no");
                            this._view_form.handleFormChange("view_preset", "no");
                            this._view_form.handleFormChange("offset", false);
                            this._view_form.handleFormChange(
                              "stime",
                              picker.startDate.unix()
                            );
                            this._view_form.handleFormChange(
                              "etime",
                              picker.startDate.unix() + 259199
                            );
                          } else {
                            this._view_form.handleFormChange("is_preset", "no");
                            this._view_form.handleFormChange("view_preset", "no");
                            this._view_form.handleFormChange("offset", false);
                            this._view_form.handleFormChange(
                              "stime",
                              picker.startDate.unix()
                            );
                            this._view_form.handleFormChange(
                              "etime",
                              picker.endDate.unix() + 1
                            );
                          }
                          this._view_form.submit();
                        }}
                      >
                        <button
                          disabled={this.state.loading && !this._IS_AUTO_RELOADING}
                          className={`selected-date-range-btn text-nowrap nofocus btn btn${
                            this._view_form && this._view_form.isInitialized()
                              ? this._view_form.getEntry("is_preset") == "yes"
                                ? "-outline"
                                : ""
                              : "-outline"
                          }-${
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? "primary"
                              : "secondary"
                          }`}
                        >
                          <span
                            className="icon-calendar"
                            style={
                              this._view_form &&
                              this._view_form.isInitialized() &&
                              this._view_form.getEntry("is_preset") == "no"
                                ? { marginRight: "8px" }
                                : null
                            }
                          />
                          {(() => {
                            if (this._view_form && this._view_form.isInitialized()) {
                              let _is_preset = this._view_form.getEntry("is_preset");
                              if (_is_preset == "no") {
                                let _stime = this.getAppContext()
                                  .momentjs(this._view_form.getEntry("stime"), "X")
                                  .format("L LT");
                                let _etime = this.getAppContext()
                                  .momentjs(this._view_form.getEntry("etime"), "X")
                                  .format("L LT");
                                let _text =
                                  _is_preset == "yes"
                                    ? "Date picker"
                                    : _stime == _etime
                                    ? _stime
                                    : _stime + " - " + _etime;
                                return _text;
                              } else {
                                return null;
                              }
                            } else {
                              return null;
                            }
                          })()}
                        </button>
                      </DateRangePicker>
                    </ReactOActionBar>
                  </Col>
                </Row>
              </ReactOForm>
            </Col>
            {this.state.data_know && this.state.data_unknow ? (
              <Col
                className={
                  this.getAppContext().media.isMobile
                    ? "mt-1"
                    : "align-self-end text-right mt-3 mt-lg-0"
                }
              >
                <div className="pr-4 mr-2">
                  {this.getAppContext().media.isMobile ? (
                    <div>
                      <div>{this.know_ap + " visible APs "}</div>
                      <div>
                        {this.know_essid.length +
                          this.unknow_essid.length +
                          " distinct ESSIDs"}
                      </div>
                      <div>
                        {this.know_bssid.length + this.unknow_bssid.length + " BSSIDs"}
                      </div>
                    </div>
                  ) : (
                    <strong>
                      {this.know_ap +
                        " visible APs\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" +
                        (this.know_essid.length + this.unknow_essid.length) +
                        " distinct ESSIDs\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" +
                        (this.know_bssid.length + this.unknow_bssid.length) +
                        " BSSIDs"}
                    </strong>
                  )}
                </div>
              </Col>
            ) : (
              <Col className="align-self-end text-right mt-3 mt-lg-0">-</Col>
            )}
          </Row>
        </Section>

        <_LoadingWrapper
          loadingPlug={
            this.state._advanced_collapse_opened_np == true ? this.state.loading : null
          }
        ></_LoadingWrapper>
        <_LoadingWrapper loadingPlug={this.state.loading}>
          {this.state.outOfRange == true ? (
            <Panel className="mx-4 mb-4" bodyClassName="p-0" rounded>
              <div className="py-2">
                <Col xs={12}>
                  <Row
                    noGutters
                    style={
                      this.getAppContext().media.isMobile ? { display: "block" } : null
                    }
                  >
                    <div className="d-flex flex-grow-1">
                      <div className="flex-grow-1">
                        <strong>No data for selected interval</strong>
                      </div>
                    </div>
                  </Row>
                </Col>
              </div>
            </Panel>
          ) : this.state.data_know && this.state.data_unknow ? (
            <div>
              <Section designType="wide">
                <Panel className="mx-4 mb-4" bodyClassName="p-0" rounded>
                  <div
                    className="notdep-bg"
                    onClick={() => {
                      this._advanced_collapse_np.toggle();
                    }}
                  >
                    <div className="py-3">
                      <Col xs={12}>
                        <Row
                          noGutters
                          style={
                            this.getAppContext().media.isMobile
                              ? { display: "block" }
                              : null
                          }
                        >
                          <div className="d-flex flex-grow-1">
                            <div className="flex-grow-1">
                              <strong>{this.know_ap + " APs from customer list"}</strong>
                            </div>
                            <div className="justify-content-end">
                              <strong>
                                {this.getAppContext().media.isMobile
                                  ? null
                                  : this.know_essid.length +
                                    " distinct ESSIDs\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" +
                                    this.know_bssid.length +
                                    " BSSIDs "}
                                <span
                                  className={
                                    this.state._advanced_collapse_opened_np == false
                                      ? "icon-caret-down-outline"
                                      : "icon-caret-up-outline"
                                  }
                                ></span>
                              </strong>
                            </div>
                          </div>
                        </Row>
                      </Col>
                    </div>
                  </div>

                  <ReactOCollapse
                    className="border-top border-2"
                    onControllerReady={(_collapse_controller) => {
                      this._advanced_collapse_np = _collapse_controller;
                      this.setState({ _advanced_collapse_opened_np: false });
                    }}
                    onOpened={() => {
                      this.setState({ _advanced_collapse_opened_np: true });
                    }}
                    onClosed={() => {
                      this.setState({ _advanced_collapse_opened_np: false });
                    }}
                    initOpen={false}
                  >
                    <ApCoverageTable
                      cols={[
                        {
                          title: "AP NAME",
                          data_key: "apname",
                          align: "center",
                          width: "15",
                        },
                        {
                          title: "ESSID",
                          data_key: "essid",
                          align: "center",
                          width: "10",
                          icon: "icon-graph-bar",
                        },
                        {
                          title: "BSSID",
                          data_key: "bssid",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "FREQ",
                          data_key: "freq",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "RSSI AVERAGE",
                          data_key: "rssi",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "PRESENCE",
                          data_key: "presence",
                          align: "center",
                          width: "10",
                        },
                      ]}
                      coverageList={this.state.data_know.obj}
                      totPres={this.state.data.tot_pres}
                      rowSpan={this.state.data_know.rowSpanAp}
                      rowClass={this.state.data_know.classApStriped}
                      from_ts={this.state.from_ts}
                      to_ts={this.state.to_ts}
                      wifi_data={this.state.data.wifi_data}
                    />
                  </ReactOCollapse>
                </Panel>
              </Section>

              <Section designType="wide">
                <Panel className="mx-4 mb-4" bodyClassName="p-0" rounded>
                  <div
                    className="notdep-bg"
                    onClick={() => {
                      this._advanced_collapse.toggle();
                    }}
                  >
                    <div className="py-3">
                      <Col xs={12}>
                        <Row
                          noGutters
                          style={
                            this.getAppContext().media.isMobile
                              ? { display: "block" }
                              : null
                          }
                        >
                          <div className="d-flex flex-grow-1">
                            <div className="flex-grow-1">
                              <strong>APs not in customer list (possible rogues)</strong>
                            </div>
                            <div className="justify-content-end">
                              <strong>
                                {this.getAppContext().media.isMobile
                                  ? null
                                  : this.unknow_essid.length +
                                    " distinct ESSIDs\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" +
                                    this.unknow_bssid.length +
                                    " BSSIDs "}
                                <span
                                  className={
                                    this.state._advanced_collapse_opened == false
                                      ? "icon-caret-down-outline"
                                      : "icon-caret-up-outline"
                                  }
                                ></span>
                              </strong>
                            </div>
                          </div>
                        </Row>
                      </Col>
                    </div>
                  </div>

                  <ReactOCollapse
                    className="border-top border-2"
                    onControllerReady={(_collapse_controller) => {
                      this._advanced_collapse = _collapse_controller;
                      this.setState({ _advanced_collapse_opened: false });
                    }}
                    onOpened={() => {
                      this.setState({ _advanced_collapse_opened: true });
                    }}
                    onClosed={() => {
                      this.setState({ _advanced_collapse_opened: false });
                    }}
                    initOpen={false}
                  >
                    <ApCoverageTable
                      cols={[
                        {
                          title: "",
                          data_key: "apname",
                          align: "center",
                          width: "15",
                        },
                        {
                          title: "ESSID",
                          data_key: "essid",
                          align: "center",
                          width: "10",
                          icon: "icon-graph-bar",
                        },
                        {
                          title: "BSSID",
                          data_key: "bssid",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "FREQ",
                          data_key: "freq",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "RSSI",
                          data_key: "rssi",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "PRESENCE",
                          data_key: "presence",
                          align: "center",
                          width: "10",
                        },
                      ]}
                      coverageList={this.state.data_unknow.obj}
                      totPres={this.state.data.tot_pres}
                      rowSpan={this.state.data_unknow.rowSpanAp}
                      rowClass={this.state.data_unknow.classApStriped}
                      rogue={true}
                      from_ts={this.state.from_ts}
                      to_ts={this.state.to_ts}
                      wifi_data={this.state.data.wifi_data}
                    />
                  </ReactOCollapse>
                </Panel>
              </Section>
            </div>
          ) : null}
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  withDefinedContext(ApCoverage, "ApCoverage", context_exposed_methods),
  {
    define: null,
  }
);
